import { BaseForm } from '@app/components/common/forms/BaseForm/BaseForm';
import { Input } from '@app/components/common/inputs/Input/Input';
import { InputNumber } from '@app/components/common/inputs/InputNumber/InputNumber';
import { Button } from '@app/components/common/buttons/Button/Button';
import { Skeleton } from '@app/components/common/Skeleton/Skeleton';
import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useMounted } from '@app/hooks/useMounted';
import { GeneralConfig, getGeneralConfig, updateGeneralConfig } from '@app/api/settings.api';
import { Col, Row } from 'antd';
import { Languages } from '@app/components/Languages';
import { useAppSelector } from '@app/hooks/reduxHooks';
import FormItemLabel from 'antd/lib/form/FormItemLabel';

const GeneralSetting: React.FC = () => {
  const [form] = BaseForm.useForm();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const { isMounted } = useMounted();
  const [language, setLanguage] = useState('en');
  const general = useAppSelector((state) => state.general.general);

  const fetch = useCallback(() => {
    setLoading(true);
    getGeneralConfig()
      .then((data) => {
        form.setFieldsValue(data);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [isMounted]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  const handleSubmit = (values: GeneralConfig) => {
    setLoading(true);
    updateGeneralConfig(values).finally(() => {
      setLoading(false);
    });
  };

  return (
    <Skeleton loading={loading}>
      <BaseForm form={form} layout="vertical" name="general-setting" onFinish={handleSubmit}>
        <Row gutter={[24, 16]}>
          <Col span={12}>
            <BaseForm.Item
              name="instagramUrl"
              label="Instagram URL"
              rules={[{ required: true, message: t('common.requiredField') }, { type: 'url' }]}
            >
              <Input />
            </BaseForm.Item>
          </Col>
          <Col span={12} />
          <Col span={12}>
            <Languages selected={language} onChange={setLanguage} />
            {general?.languages.map((item) => (
              <BaseForm.Item
                key={item.code}
                hidden={language !== item.code}
                name={['faq', item.code]}
                label="FAQ URL"
                rules={[{ required: item.code === 'en', message: t('common.requiredField') }, { type: 'url' }]}
              >
                <Input />
              </BaseForm.Item>
            ))}
          </Col>
        </Row>
        <Button type="primary" style={{ marginTop: '15px', float: 'right' }} htmlType="submit">
          Save
        </Button>
      </BaseForm>
    </Skeleton>
  );
};

export default GeneralSetting;
